import React from 'react';
import { IntegrationError } from '../../@types';
import ErroItem from './ErroItem';

interface IntegrationErrorsListProps {
  errors: IntegrationError[];
  isLoading: boolean;
  isLoadingMore: boolean;
  hasNextPage: boolean;
  onLoadMore: () => void;
  onResync: (id: string) => void;
}

const IntegrationErrorsList: React.FC<IntegrationErrorsListProps> = ({
  errors,
  isLoading,
  isLoadingMore,
  hasNextPage,
  onLoadMore,
  onResync,
}) => (
  <div className="integration-errors-list-wrapper">
    {isLoading && (
      <div className="empty-state">
        <i className="pi pi-spin pi-spinner" />
        <p>Carregando registros</p>
      </div>
    )}
    {!isLoading && errors.length === 0 && (
      <div className="empty-state">
        <i className="pi pi-search" />
        <p>Nenhum registro encontrado</p>
      </div>
    )}
    {!isLoading && errors.length > 0 && (
      <div className="integration-errors-list">
        {errors.map((erro) => (
          <ErroItem key={erro.id} erro={erro} onResync={onResync} />
        ))}

        {(hasNextPage || isLoadingMore) && (
          <div className="integration-errors-list-load-more">
            <button
              type="button"
              className="p-button p-component p-button-text p-button-sm"
              onClick={onLoadMore}
              disabled={isLoadingMore}
            >
              <span className="p-button-label p-c">
                {isLoadingMore ? 'Carregando...' : 'Carregar mais'}
              </span>
            </button>
          </div>
        )}
      </div>
    )}
  </div>
);

export default React.memo(IntegrationErrorsList);
